import { useRef } from 'react';
import { useStore } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import type { RootState } from '@/app/store/index';
import { decideMountLoadMode, type MountLoadMode } from '../utils/mountLoadMode';

/** Decided once per history entry, from the slice as persisted, before any hydration can change it. */
export const useMountLoadMode = (sameJourney: boolean): MountLoadMode => {
    const { key } = useLocation();
    const { quoteId: urlQuoteId } = useParams<{ quoteId: string }>();
    const store = useStore<RootState>();
    const decided = useRef<{ key: string; mode: MountLoadMode } | null>(null);

    if (decided.current?.key !== key) {
        const { quoteId, version, saveDirty } = store.getState().quote;
        const mode = decideMountLoadMode({ urlQuoteId, sameJourney, persisted: { quoteId, version, saveDirty } });
        decided.current = { key, mode };
    }
    return decided.current.mode;
};
